export default __webpack_public_path__ + "../img/BehindTheHotel.gif";